import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import dynamic from 'next/dynamic';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/resources/terms-and-conditions/TermsAndConditions.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/TermsAndConditions/components/SectionHeader'));
const SectionContent = dynamic(() => import('sections/Resources/TermsAndConditions/components/SectionContent'));

export default function TermsAndConditions() {
  return (
    <section className={cn('terms-and-conditions')}>
      <SectionHeader />
      <SectionContent />
    </section>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Terms and Conditions of DF Alliance | DF Alliance',
      description: 'Understand DF Alliance\'s terms & conditions to stay informed on guidelines that govern the use of our global logistics and freight forwarding services.',
      path: '/resources/terms-and-conditions',
    },
  };
};

TermsAndConditions.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
